<template>
    <div class="GsAppCompont_Hr" :style="{marginBottom: marginBottom + 'px'}"></div>
</template>
<script>
export default {
    name: "GsAppCompontHr",
    props: {
        marginBottom: {
            type: [Number, String],
            default: '10'
        }
    }
}
</script>
<style lang="scss" scoped>
    .GsAppCompont_Hr{
        margin: 0 auto;
        max-width: $Page_MaxWidth;
        height: 1px;
        position: relative;
        &::after{
            content: "\0020";
            overflow: hidden;
            position: absolute;
            box-sizing: border-box;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            @include PageHr_Color($PageHr_Color);
            transform-origin: 0 0;
        }
    }
    @media (min--moz-device-pixel-ratio: 1.5) and (max--moz-device-pixel-ratio: 2.49), (-webkit-min-device-pixel-ratio: 1.5) and (-webkit-max-device-pixel-ratio: 2.49), (min-device-pixel-ratio: 1.5) and (max-device-pixel-ratio: 2.49), (min-resolution: 144dpi) and (max-resolution: 239dpi), (min-resolution: 1.5dppx) and (max-resolution: 2.49dppx) {
        .GsAppCompont_Hr{
            &::after {
                width: 200%;
                height: 200%;
                transform: scale(.5);
            }
        }
    }
    @media (min--moz-device-pixel-ratio: 2.5), (-webkit-min-device-pixel-ratio: 2.5), (min-device-pixel-ratio: 2.5), (min-resolution: 240dpi), (min-resolution: 2.5dppx){
        .GsAppCompont_Hr{
            &::after {
                width: 300%;
                height: 300%;
                transform: scale(.33333);
            }
        }
    }
    
</style>